import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { Overline } from "./Shared";
import { TESTIMONIALS } from "../../lib/site";

export const Testimonials = () => (
  <section id="testimonials" className="relative py-24 md:py-32 bg-charcoal border-y border-white/10" data-testid="testimonials-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
        <div>
          <Overline>Client Words</Overline>
          <h2 className="mt-5 font-heading font-light text-4xl md:text-6xl text-white leading-[1.02] max-w-xl">
            Trusted for the <span className="italic text-gold">journeys that matter</span>
          </h2>
        </div>
        <div className="flex items-center gap-2 text-gold">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={18} fill="#D4AF37" strokeWidth={0} />
          ))}
          <span className="ml-2 text-white/60 text-sm">5.0 · Rated by clients</span>
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="flex flex-col rounded-sm border border-white/10 bg-ink p-8 hover:border-gold/30 transition-colors duration-500"
            data-testid={`testimonial-${i}`}
          >
            <Quote size={28} className="text-gold/70" />
            <blockquote className="mt-6 flex-1 font-heading italic text-lg md:text-xl text-white/85 leading-relaxed">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-8 border-t border-white/10 pt-5">
              <span className="block text-white text-sm font-medium">{t.name}</span>
              <span className="block text-white/45 text-xs uppercase tracking-widest mt-1">{t.role}</span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
